<template>
    <el-form inline>
        <el-form-item>
            <el-input v-model="searchKey" placeholder="搜索"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button @click="doSearch">搜索</el-button>
            <el-button @click="doReset">重置</el-button>
            <el-button @click="$router.push('./ProjectEdit')">添加</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    name: 'ProjectSearch',

    data() {
        return {
            searchKey: ''
        };
    },

    methods: {
        doSearch() {},
        doReset() {}
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/ProjectSearch.vue